import React, { Component } from 'react'
import dataIcon from "app/styles/images/sp/data-selected.svg"
import DataTable from "./container/DataTable"
import DataHeader from "./container/DataHeader"
import Store from "app/stores/pgs/dataStatistics"
import TimingTask from '../data_statistics/timingTask'
import { Tabs } from 'antd'
import './Index.scss'

const { TabPane } = Tabs

export default class index extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
  }

  onTabsChange = (e) => {
    e === 1 ? this.store.getTimingTaskData() :
      this.store.getTableData()
  }

  render() {
    return (
      <div className="pgs data-statistics data-view">
        <h2 className="page-title"><img alt="" src={dataIcon} />数据回顾</h2>
        <Tabs
          type="card"
          defaultActiveKey="1"
          onChange={this.onTabsChange}
        >
          <TabPane tab="定时任务统计" key="1">
            <TimingTask store={this.store} />
          </TabPane>
          <TabPane tab="通过查询时间统计" key="2">
            <div className="clearfix wrapper-box-first">
              <DataHeader store={this.store} />
            </div>
            <div>
              <DataTable store={this.store} />
            </div>
          </TabPane>
        </Tabs>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/pgs/data_statistics/index.js